import React from "react";
import Grid from "../Grid/grid";
import Title from "../title";
import Process from "../process";
import webProcess from "./data/web-process";
import contentImage from "../../Assets/image/services-pages-images/web-development/web-development-content.webp";

function WebDevelopmentProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={webProcess}
        img={contentImage}
        title="Web Development"
        description="Crafting Scalable & High-Performance Websites – Custom Web Development Solutions Designed for Your Growth."
      />
    </section>
  );
}

export default WebDevelopmentProcess;
